// ---------------------------------------------
// Lookup data shared across the wizard
// ---------------------------------------------

export const COUNTRIES = [
  { code: "US", name: "United States",    flag: "🇺🇸" },
  { code: "DE", name: "Germany",          flag: "🇩🇪" },
  { code: "GB", name: "United Kingdom",   flag: "🇬🇧" },
  { code: "FR", name: "France",           flag: "🇫🇷" },
  { code: "CY", name: "Cyprus",           flag: "🇨🇾" },
];

export const CURRENCIES = [
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
];

/** Top-level shipping-method categories shown in the UI */
export const METHOD_TYPES = ["flat", "tiered", "dynamic"];

/** If the merchant picks “dynamic”, they must pick a basis */
export const DYNAMIC_BASES = ["weight", "dimension"];

export const COURIERS = ["UPS", "DHL", "FedEx"];
